import React from "react";
import styles from "./CygnusFormPageSidebar.module.css";
import * as Icon from "react-bootstrap-icons";
import TextInput from "../../../TextInput/TextInput";
import DraggableFieldList from "./components/DraggableFieldList/DraggableFieldList";
import { CygnusFormPageSidebarProps } from "./CygnusFormPageSidebar.utils";

/**
 * Sidebar that infers page breaks from field list and allows renaming pages.
 */
const CygnusFormPageSidebar: React.FC<CygnusFormPageSidebarProps> = ({
  fields,
  pageNames,
  activePageIndex,
  setPageName,
  setActivePageIndex,
  updateFieldOrder,
}) => {
  const getPages = () => {
    const pages: number[] = [];
    fields.forEach((field, i) => {
      if (i === 0 || field.pageBreak) {
        pages.push(i);
      }
    });
    return pages;
  };

  const pages = getPages();

  return (
    <div className={styles.sidebarContainer}>
      <div className={styles.sidebarHeader}>
        <div>Pages</div>
        <div>
          <Icon.CollectionFill />{" "}
        </div>
      </div>
      <div className={styles.pagesWrapper}>
        {pages.map((_, index) => (
          <div
            key={index}
            className={`${styles.pageItem} ${
              activePageIndex === index ? styles.active : ""
            }`}
            onClick={() => setActivePageIndex(index)}
          >
            <TextInput
              field={{
                id: String(index),
                type: "text",
                label: "",
                customLabel: "",
                value: pageNames[index] ?? `Page ${index}`,
                validation: [{ type: "required", message: "Required!" }],
              }}
              handleChange={(_, event) =>
                setPageName(index, event.target.value)
              }
              handleBlur={() => {}}
              handleSelect={() => {}}
            />
          </div>
        ))}
      </div>
      <div className={styles.sidebarHeader}>
        <div>Fields Order</div>
        <div>
          <Icon.Stack />{" "}
        </div>
      </div>
      <div className={styles.draggableFieldsWrapper}>
        <DraggableFieldList
          fields={fields}
          updateFieldOrder={updateFieldOrder}
        />
      </div>
    </div>
  );
};

export default CygnusFormPageSidebar;
